<template>
  <div class="Kanit">
    <slot name="header"></slot>

    <div style="max-width: 500px; position: relative" class="mx-auto">
      <div class="text-center" style="position: relative; bottom: 10px">
        <v-avatar size="130px">
          <v-img :src="profile.pictureUrl"></v-img>
        </v-avatar>
      </div>
      <div style="position: absolute; right: 0px; top: 0px">
        <v-btn @click="logout" text color="primary">Logout</v-btn>
      </div>
      <div class="px-5">
        <div class="primary--text text-center mt-2" style="font-weight: 500; font-size: 24px">{{ member.firstname }} {{ member.lastname }}</div>
        <div class="text-center mt-3">
          คุณมีทั้งหมด
          <span v-if="loading">
            <v-progress-circular indeterminate size="20" color="#22bef0"></v-progress-circular>
          </span>
          <span v-else style="color: #22bef0; font-size: 30px; font-weight: 500">{{ numberFormat($store.state.currentPoint) }}</span>
          เครื่อง
        </div>
        <div class="text-center px-5 pt-4">
          <v-btn @click="query.view = 'PointHistory'" block color="primary">
            ดูประวัติการสะสมเครื่อง
          </v-btn>
          <v-btn @click="$liff.closeWindow()" class="mt-4" dark color="grey" block>
            ปิด
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  computed: {
    member() {
      return this.$store.state.member;
    },
  },
  mounted() {
    this.checkPoint();
  },
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    logout() {
      this.$swal
        .fire({
          text: "ต้องการออกจากระบบ ?",
          showCancelButton: true,
        })
        .then((result) => {
          if (result.value) {
            axios
              .post(
                this.serverUrl + "yasale/logout",
                {
                  userid: this.userid,
                  pageid: this.query.pageid,
                },
                { headers: { AUTHORIZATION: "Bearer xxx xxx" } }
              )
              .then(async (response) => {
                if (response.data.responsecode == 200) {
                  this.$store.state.redirectview = "";
                  this.query.view = "Login";
                } else {
                  await this.$swal.fire({
                    text: response.data.reason,
                  });
                  this.$liff.closeWindow();
                }
              });
          }
        });
    },
    checkPoint() {
      return new Promise((resolve) => {
        this.loading = true;
        axios
          .get(this.serverUrl + "yasale/member-points", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: {
              memberId: this.$store.state.member.id,
            },
          })
          .then((response) => {
            if (response.data.responsecode == 200) {
              this.$store.state.currentPoint = response.data.data[0].points;
            }
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
